export enum StatsType {
  SHARED_LINK = 'shared_link',
  FOLLOWING_LINK = 'following_link'
}
